<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">     
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.descricao"
            :valid.sync="fieldsComputed.descricao.valid"
            :label="fieldsComputed.descricao"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div> 
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.elemento_tecnologico"
            :valid.sync="fieldsComputed.elemento_tecnologico.valid"
            :label="fieldsComputed.elemento_tecnologico"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.desafio_tecnologico"
            :valid.sync="fieldsComputed.desafio_tecnologico.valid"
            :label="fieldsComputed.desafio_tecnologico"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.metodologia"
            :valid.sync="fieldsComputed.metodologia.valid"
            :label="fieldsComputed.metodologia"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>          
    </div>
  </div>
</template>

<script>
import { cloneDeep, debounce } from "lodash";
import fields from '../LBEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
  },
  data() { 
    return {
      fields,
      objetivoDisplay: '',
    }
  },
  computed: {
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.objetivos);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
  },
  methods: {
    updateObjetivoDisplay: debounce(function() {
      this.objetivoDisplay = `${this.projeto.descricao || ''} </br> ${this.projeto.elemento_tecnologico || ''} </br> ${this.projeto.desafio_tecnologico || ''}`;
    }, 1000),
  },
  watch: {
    'projeto.descricao': {
      handler() {
        this.updateObjetivoDisplay();
      },
      immediate: true
    },
    'projeto.elemento_tecnologico': {
      handler() {
        this.updateObjetivoDisplay();
      },
      immediate: true
    },
    'projeto.desafio_tecnologico': {
      handler() {
        this.updateObjetivoDisplay();
      },
      immediate: true
    }
  },
  created() {
    this.updateObjetivoDisplay();
  },
  mounted() {},
  beforeDestroy() {
    // this.updateObjetivoDisplay.cancel();
  }
}
</script>

<style scoped>
</style>
